import { AssertValidate } from "mobx-firelink";
export function ValidateDBData(data) {
    function ValidateCollection(collection, itemType) {
        (collection || {}).VValues(1).forEach(entry => {
            AssertValidate(itemType, entry, `${itemType} invalid`);
        });
    }
    ValidateCollection(data.attributes, "Attribute");
    ValidateCollection(data.books, "Book");
    ValidateCollection(data.characters, "Character");
    ValidateCollection(data.events, "BookEvent");
    ValidateCollection(data.mapObjects, "MapObject");
    ValidateCollection(data.seeds, "Seed");
}
